import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import dayjs from 'dayjs';
import { LOGIN } from 'src/store/types';
export default Vue.extend({
    props: {
        hasSidebar: { type: Boolean, default: false }
    },
    data() {
        return {
            timer: null,
            timeLeft: 0,
        };
    },
    computed: {
        ...mapGetters(['currentSite', 'hasRequestErrors', 'serverErrors', 'hasConnectionErrors']),
        showMessage() {
            return this.timeLeft > 0;
        },
        timeDisplay() {
            return dayjs.duration(this.timeLeft * 1000).format('mm:ss');
        },
    },
    mounted() {
        this.startCountdown();
    },
    methods: {
        ...mapActions({ LOGIN }),
        startCountdown() {
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                if (this.$auth.refreshTokenExpired()) {
                    this.timeLeft = this.$auth.idTokenClaims.exp - Math.floor(Date.now() / 1000);
                }
            }, 1000);
        },
    },
});
